import { logger } from 'logger';

const tsKey = (key: string) => `${key}_ts`;

export function readFreshCache<T>(key: string, ttlMs: number, isValid?: (data: T) => boolean): T | null {
  try {
    const raw = window.localStorage.getItem(key);
    const ts = Number(window.localStorage.getItem(tsKey(key)));
    if (!raw || !ts || Date.now() - ts > ttlMs) {
      return null;
    }
    const data = JSON.parse(raw) as T;
    if (!data || (isValid && !isValid(data))) {
      return null;
    }
    return data;
  } catch (e) {
    logger.warn(`localStorageCache: read "${key}" failed`, e);
    return null;
  }
}

export function writeCache(key: string, data: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
    window.localStorage.setItem(tsKey(key), String(Date.now()));
  } catch (e) {
    logger.warn(`localStorageCache: write "${key}" failed`, e);
  }
}

export function invalidateCache(key: string): void {
  try {
    window.localStorage.removeItem(tsKey(key));
  } catch (e) {
    logger.warn(`localStorageCache: invalidate "${key}" failed`, e);
  }
}

export function hasStaleCache(key: string): boolean {
  try {
    return !!window.localStorage.getItem(key);
  } catch (e) {
    logger.warn(`localStorageCache: stale check "${key}" failed`, e);
    return false;
  }
}
